/**
 * Service para calcular tributos IBS/CBS
 * Aplica apenas para empresas que não são MEI ou SIMPLES NACIONAL
 */

const TYPE_ENTERPRISE_SIMPLES_NACIONAL = "3"
const TYPE_ENTERPRISE_MEI = "4"

/**
 * Calcula os valores de IBS/CBS para um produto
 * @param {Object} product - Produto com dados tributários
 * @param {Object} enterprise - Empresa com regime tributário
 * @returns {Object} Objeto com valores calculados de IBS/CBS
 */
async function calculateIbsCbs(product, enterprise) {
    try {
        console.log('');
        console.log('=== DEBUG IBS/CBS CALCULATION ===');
        console.log('Enterprise tax_regime:', enterprise.tax_regime);
        console.log('Product ID:', product.product_id);
        console.log('Product aliquot_ibs_cbs:', product.aliquot_ibs_cbs);
        console.log('Product value_subtotal_product:', product.value_subtotal_product);

        if (!shouldCalculateIbsCbs(enterprise.tax_regime)) {
            console.log('IBS/CBS não aplicável para regime:', enterprise.tax_regime);
            return getZeroedIbsCbsValues();
        }

        if (!product.aliquot_ibs_cbs) {
            console.log('Produto sem aliquot_ibs_cbs configurado:', product.product_id);
            return getZeroedIbsCbsValues();
        }

        const aliquotIbsCbs = product.aliquot_ibs_cbs;
        const baseValue = parseFloat(product.value_subtotal_product || 0);

        console.log('Base value for calculation:', baseValue);
        console.log('Aliquot IBS UF:', aliquotIbsCbs.aliquot_ibs_uf);
        console.log('Aliquot IBS MUN:', aliquotIbsCbs.aliquot_ibs_mun);
        console.log('Aliquot CBS:', aliquotIbsCbs.aliquot_cbs);

        const valueBaseIbsUf = baseValue;
        const valueIbsUf = (baseValue * parseFloat(aliquotIbsCbs.aliquot_ibs_uf || 0)) / 100;

        const valueBaseIbsMun = baseValue;
        const valueIbsMun = (baseValue * parseFloat(aliquotIbsCbs.aliquot_ibs_mun || 0)) / 100;

        const valueBaseCbs = baseValue;
        const valueCbs = (baseValue * parseFloat(aliquotIbsCbs.aliquot_cbs || 0)) / 100;

        const valueTotalIbs = valueIbsUf + valueIbsMun;
        const valueTotalTaxUf = valueIbsUf;
        const valueTotalTaxMun = valueIbsMun;

        console.log('Calculated values:');
        console.log('- IBS UF:', valueIbsUf);
        console.log('- IBS MUN:', valueIbsMun);
        console.log('- CBS:', valueCbs);
        console.log('- Total IBS:', valueTotalIbs);
        console.log('- CBS Total (should match CBS):', valueCbs);

        return {
            // Campos que existem no backend - apenas com sufixo _prod
            value_base_tax_selective_prod: 0,
            value_tax_selective_prod: 0,
            value_total_tax_uf_prod: parseFloat(valueTotalTaxUf.toFixed(2)),
            value_total_tax_mun_prod: parseFloat(valueTotalTaxMun.toFixed(2)),
            value_total_ibs_prod: parseFloat(valueTotalIbs.toFixed(2)),
            value_total_cred_presumid_prod: 0,
            value_deferimento_prod: 0,
            value_total_returns_prod: 0,
            value_exemption_prod: 0,
            value_cbs_total_prod: parseFloat(valueCbs.toFixed(2)),
            value_base_total_cbs_mono_prod: 0,
            value_total_cbs_mono_prod: 0
        };

    } catch (error) {
        console.error('Erro ao calcular IBS/CBS:', error);
        return getZeroedIbsCbsValues();
    }
}

/**
 * Verifica se a empresa deve calcular IBS/CBS
 * @param {string} taxRegime - Regime tributário da empresa
 * @returns {boolean} True se deve calcular IBS/CBS
 */
function shouldCalculateIbsCbs(taxRegime) {
    return taxRegime !== TYPE_ENTERPRISE_SIMPLES_NACIONAL && 
           taxRegime !== TYPE_ENTERPRISE_MEI;
}

/**
 * Retorna objeto com todos os valores IBS/CBS zerados
 * @returns {Object} Objeto com valores zerados
 */
function getZeroedIbsCbsValues() {
    return {
        // Campos que existem no backend - apenas com sufixo _prod
        value_base_tax_selective_prod: 0,
        value_tax_selective_prod: 0,
        value_total_tax_uf_prod: 0,
        value_total_tax_mun_prod: 0,
        value_total_ibs_prod: 0,
        value_total_cred_presumid_prod: 0,
        value_deferimento_prod: 0,
        value_total_returns_prod: 0,
        value_exemption_prod: 0,
        value_cbs_total_prod: 0,
        value_base_total_cbs_mono_prod: 0,
        value_total_cbs_mono_prod: 0
    };
}

module.exports = {
    calculateIbsCbs,
    shouldCalculateIbsCbs,
    getZeroedIbsCbsValues
};